window.Blimp = window.Blimp || {};

class ZoomView extends Backbone.View {
  get el() {
    return '.zoom';
  }

  get events() {
    return {
      'click .photo': 'close',
      'click .photo img': 'prevent_event_bubbling',
      'click .photo .video-player': 'prevent_event_bubbling',
      'click .close': 'close',
      'click .delete': 'delete',
      'click .arrow.left': 'previous',
      'click .arrow.right': 'next'
    };
  }

  initialize() {
    this.close = this.close.bind(this);
    this.previous = this.previous.bind(this);
    this.next = this.next.bind(this);
  }

  up(report, photo) {
    this.is_up = true;
    this.report = report;
    this.photo = photo;
    this.photo_view = new Blimp.ZoomPhotoView({ model: this.photo }).render();
    this.$el.append(this.photo_view.el).show();
    this.updateTitle();

    this.preload_previous();
    this.preload_next();

    key('esc, enter', this.close);
    key('left, up', _.debounce(this.previous, 100, true));
    key('right, down', _.debounce(this.next, 100, true));
  }

  down() {
    if (!this.is_up) return;
    this.is_up = false;
    if (this.photo_view) this.photo_view.remove();
    this.photo_view = null;
    this.photo = null;
    this.$el.hide();
    this.restoreTitle();

    $(window).off('resize orientationchange', this._debouncedLayout);
    key.unbind('esc');
    key.unbind('enter');
    key.unbind('up');
    key.unbind('down');
    key.unbind('left');
    key.unbind('right'); // doesnt support multiple keys
  }

  close(e) {
    if (e && !(e instanceof KeyboardEvent) && e.target && e.target.tagName === 'A' && e.target.className !== 'close') {
      return true;
    }
    Blimp.app.navigate(this.return_url || this.report.url(), { trigger: true }); // FIXME explodes if report was just deleted by deleting all photos
    return false;
  }

  delete(e) {
    if (confirm(`Are you sure you want to delete photo ${this.photo.index()}/${this.report.photos.length}?`)) {
      this.photo.destroy();
      if (this.report.photos.length > 0) {
        this.previous();
      } else {
        this.report.destroy();
        this.close();
      }
    }
    return false;
  }

  // Returning false will prevent event from bubbling to other tree
  // elements, useful to prevent activation of other events.
  prevent_event_bubbling(e) {
    return false;
  }

  previous() {
    this.photo_view.remove();
    this.photo_view = null;
    this.photo = this.photo.previous();
    this.photo_view = new Blimp.ZoomPhotoView({ model: this.photo }).render(false);
    this.preload_previous();
    this.$el.append(this.photo_view.el);
    this.updateTitle();
    Blimp.app.navigate(`${this.photo.url()}`, { replace: true });
    return false;
  }

  next() {
    this.photo_view.remove();
    this.photo_view = null;
    this.photo = this.photo.next();
    this.photo_view = new Blimp.ZoomPhotoView({ model: this.photo }).render(false);
    this.preload_next();
    this.$el.append(this.photo_view.el);
    this.updateTitle();
    Blimp.app.navigate(`${this.photo.url()}`, { replace: true });
    return false;
  }

  preload_previous() {
    const photo = this.photo.previous();
    if (photo.is_video() || photo.preloaded) return;
    const img = new Image();
    img.onload = () => photo.preloaded = true;
    img.src = photo.zoom_url();
  }

  preload_next() {
    const photo = this.photo.next();
    if (photo.is_video() || photo.preloaded) return;
    const img = new Image();
    img.onload = () => photo.preloaded = true;
    img.src = photo.zoom_url();
  }

  updateTitle() {
    if (!this.title_was) {
      this.title_was = window.document.title;
    }
    window.document.title = `${this.photo.index()}/${this.report.photos.size()} – ${this.title_was}`;
  }

  restoreTitle() {
    window.document.title = this.title_was;
  }
}

Blimp.ZoomView = ZoomView;
